/**
 * Wykrywanie możliwości GPU i dostępności WebGL
 */
export function detectGPU() {
    const info = {
        webglSupported: false,
        webgl2Supported: false,
        hasDedicatedGPU: false,
        isHighEnd: false,
        isSoftwareRenderer: false,
        renderer: 'unknown',
        vendor: 'unknown',
        maxTextureSize: 0,
        maxVertexAttribs: 0
    };
    
    // Sprawdź WebGL1
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    
    if (!gl) {
        console.warn('[GPU] WebGL nie jest dostępne!');
        return info;
    }
    
    info.webglSupported = true;
    
    // Pobierz informacje o rendererze (GPU)
    const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
    if (debugInfo) {
        info.renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || 'unknown';
        info.vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) || 'unknown';
        
        const rendererLower = info.renderer.toLowerCase();
        
        // Wykryj software renderer
        const isBasicRenderDriver = (
            rendererLower.includes('basic render driver') ||
            rendererLower.includes('microsoft basic render driver')
        );
        
        const isDefinitelySoftware = (
            rendererLower.includes('software') ||
            rendererLower.includes('llvmpipe') ||
            rendererLower.includes('mesa software')
        );
        
        if (isBasicRenderDriver) {
            console.warn('[GPU] ⚠️ Wykryto "Basic Render Driver" - przeglądarka może używać software renderera zamiast GPU!');
            console.warn('[GPU] Jeśli masz dedykowane GPU (np. NVIDIA), sprawdź:');
            console.warn('[GPU] 1. Ustawienia przeglądarki: chrome://settings/system → "Użyj akceleracji sprzętowej"');
            console.warn('[GPU] 2. Sterowniki NVIDIA: Panel sterowania NVIDIA → Zarządzanie ustawieniami 3D → Programy');
            console.warn('[GPU] 3. Windows Graphics Settings: Ustawienia → System → Wyświetlanie → Graphics settings');
            info.isSoftwareRenderer = true;
        } else if (isDefinitelySoftware) {
            info.isSoftwareRenderer = true;
            console.warn('[GPU] ⚠️ Wykryto software renderer - wydajność będzie bardzo niska!');
        }
        
        // Wykryj dedykowane GPU
        info.hasDedicatedGPU = (
            rendererLower.includes('nvidia') ||
            rendererLower.includes('amd') ||
            rendererLower.includes('radeon') ||
            rendererLower.includes('geforce') ||
            rendererLower.includes('rtx') ||
            rendererLower.includes('gtx')
        ) && !rendererLower.includes('intel');
        
        // Wykryj wysokiej klasy GPU
        info.isHighEnd = (
            rendererLower.includes('rtx') ||
            rendererLower.includes('geforce rtx') ||
            rendererLower.includes('radeon rx') ||
            rendererLower.includes('amd radeon rx') ||
            rendererLower.includes('geforce gtx 10') ||
            rendererLower.includes('geforce gtx 16') ||
            rendererLower.includes('geforce gtx 20') ||
            rendererLower.includes('geforce gtx 30') ||
            rendererLower.includes('geforce gtx 40')
        );
    }
    
    // Sprawdź WebGL2
    const gl2 = canvas.getContext('webgl2');
    if (gl2) {
        info.webgl2Supported = true;
    }
    
    // Pobierz limity GPU
    info.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE) || 0;
    info.maxVertexAttribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS) || 0;
    
    // Dodatkowe sprawdzenie - jeśli maxTextureSize jest duże i to nie software renderer
    if (!info.isHighEnd && !info.isSoftwareRenderer && info.maxTextureSize >= 16384) {
        const rendererLower = info.renderer.toLowerCase();
        if (!rendererLower.includes('intel') || rendererLower.includes('iris') || rendererLower.includes('xe')) {
            info.isHighEnd = true;
        }
    }
    
    return info;
}

/**
 * Sprawdzenie dostępności WebGL
 */
export function isWebGLAvailable() {
    try {
        const canvas = document.createElement('canvas');
        return !!(window.WebGLRenderingContext && 
                 (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
    } catch (e) {
        return false;
    }
}

